import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import i18n from "i18next";
import "../vodafone.css"
import {Col, Row} from "reactstrap";
import StatusBar from "../components/StatusBar";
import technicianAppointmentRequired from "../technicianRequired";

class StatusBarDesktop extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        return <Row style={{paddingTop:"13vh", marginBottom:"50px"}}>
            <Col xs={12}  lg={{ size: 10, offset: 1 }}>
                <StatusBar
                    currentStage={this.props.currentStage}
                    technicianAppointmentRequired={this.props.technicianAppointmentRequired}
                    customerWillGetAPackage={this.props.customerWillGetAPackage}
                />
            </Col>
        </Row>
    }
}

export {StatusBarDesktop}